import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';

@Pipe({
    name: 'customCurrency',
    pure: false  // Mark the pipe as impure so it can re-render on changes
})
export class CustomCurrencyPipe implements PipeTransform, OnDestroy {
     langSubscription: any = null;
     currentLanguage: string;
    constructor(
        private currencyPipe: CurrencyPipe,
        private translate: TranslateService,
        private cdr: ChangeDetectorRef  // Inject ChangeDetectorRef to manually trigger change detection
    ) {
        // Set up subscription to language changes
        this.langSubscription = this.translate.onLangChange.subscribe(event => {
            this.currentLanguage = event.lang;
            // Manually trigger change detection to ensure the pipe re-renders
            this.cdr.markForCheck();  // Mark the pipe for change detection
            this.cdr.detectChanges(); // Trigger change detection
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from the language change subscription
        if (this.langSubscription) {
            this.langSubscription.unsubscribe();
        }
    }

    transform(
        value: number,
        currencyCode: string = 'EUR',
        display: string | boolean = 'symbol',
        digitsInfo: string = '1.0-2',
        locale?: string
    ): string {
        const currentLang = this.translate.currentLang || 'it';
        locale = currentLang === 'it' ? 'it-IT' : 'en-IN';
        if (currencyCode === 'EUR') {
            // For EUR, add space before the Euro symbol
            const formattedValue = this.currencyPipe.transform(value, ' ', false, digitsInfo, locale);
            return `${formattedValue} €`;
        } else {
            // Use the default currencyPipe transformation for other currencies
            return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale);
        }
    }
}
